import Vue from "vue";
import vuetify from "../vuetify.js";
import ContactApp from "../components/contact/ContactApp.vue";
import depsloader from "../depsloader";

export default function() {
  const element = document.querySelector("#vue-contact");

  if (element) {
    depsloader.load("vue-i18n").then((VueI18n) => {
      Vue.use(VueI18n.VueI18n);
      let vueArgs = {};

      let renderFn = ContactApp;

      if (element.dataset.name) {
        if (element.dataset.name == "ratgeber") {
          renderFn = require("../components/contact/RatgeberApp.vue").default;
        }

        if (element.dataset.name == "testimonial") {
          renderFn = require("../components/contact/TestimonialApp.vue").default;
        }
      }

      vueArgs = {...vueArgs, ...{
        el: element,

        components: {
          ContactApp
        },

        vuetify,
        i18n: new VueI18n.VueI18n(VueI18n.options),

        render: h => h(renderFn)
      }};

      new Vue(vueArgs)
    });
  }
}

